/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkflowTrigger } from './workflow-trigger';
import {
    WorkflowTriggerFromJSON,
    WorkflowTriggerFromJSONTyped,
    WorkflowTriggerToJSON,
    WorkflowTriggerToJSONTyped,
} from './workflow-trigger';

/**
 * 
 * @export
 * @interface WorkflowPutRequest
 */
export interface WorkflowPutRequest {
    /**
     * The id of the conversation type to be assigned to this conversation.
     * @type {string}
     * @memberof WorkflowPutRequest
     */
    conversationTypeId?: string | null;
    /**
     * The trigger configuration for this workflow.
     * @type {WorkflowTrigger}
     * @memberof WorkflowPutRequest
     */
    trigger: WorkflowTrigger;
    /**
     * A human-readable name for this workflow.
     * @type {string}
     * @memberof WorkflowPutRequest
     */
    name?: string | null;
    /**
     * A description of what this workflow does.
     * @type {string}
     * @memberof WorkflowPutRequest
     */
    description?: string | null;
    /**
     * The workflow status. The workflow will run only if it is enabled.
     * @type {boolean}
     * @memberof WorkflowPutRequest
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the WorkflowPutRequest interface.
 */
export function instanceOfWorkflowPutRequest(value: object): value is WorkflowPutRequest {
    if (!('trigger' in value) || value['trigger'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function WorkflowPutRequestFromJSON(json: any): WorkflowPutRequest {
    return WorkflowPutRequestFromJSONTyped(json, false);
}

export function WorkflowPutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowPutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'conversationTypeId': json['conversation_type_id'] == null ? undefined : json['conversation_type_id'],
        'trigger': WorkflowTriggerFromJSON(json['trigger']),
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'enabled': json['enabled'],
    };
}

export function WorkflowPutRequestToJSON(json: any): WorkflowPutRequest {
    return WorkflowPutRequestToJSONTyped(json, false);
}

export function WorkflowPutRequestToJSONTyped(value?: WorkflowPutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conversation_type_id': value['conversationTypeId'],
        'trigger': WorkflowTriggerToJSON(value['trigger']),
        'name': value['name'],
        'description': value['description'],
        'enabled': value['enabled'],
    };
}

